module.exports = __webpack_public_path__ + "img/low-fat-chili.7314ca30.jpg";